<template>
  <div class="body">
    <p
      v-for="(item, index) in companyObj.info"
      :key="index">
      {{ item }}
    </p>
  </div>
</template>
<style lang="scss" scoped>
@import "@/scss/base.scss";

.body {
  padding: (15vw / $w) 0 (16vw / $w) 0;
  font-size: (11vw / $w);
  font-family:PingFangSC-Regular,PingFang SC;
  color: #CCCCCC;
  line-height: (17vw / $w);
  text-align: center;
}
</style>
<script>
import Vue from "vue";
export default Vue.extend({
  props: ["companyObj"],
})
</script>
